import { Link, useHistory, useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { IoIosFunnel } from "react-icons/io";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";

import Item from "./Item/Item";
import BackButton from "../Components/BackButton";

import { domain } from "config.js";

var lastParams = {};
var lastLocationParams = "";

function SearchResult({ properties, resultSet, totalPages, changeTotalPages, ImageCache, title }) {
    const history = useHistory();
    const location = useLocation();
    const [checked, setChecked] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageInputValue, setPageInputValue] = useState(1);

    const selectSort = useRef();
    const topScrollRef = useRef();

    // console.log("CHECKED = ", checked);

    useEffect(() => {
        document.title = title;

        var pricesort = Object.fromEntries(new URLSearchParams(location.search))?.pricesort
        if (pricesort) selectSort.current.value = pricesort;
    }, [title]);

    useEffect(() => {

        // console.log("CHECKING", lastLocationParams + " vs " +  location.search)
        if (lastLocationParams != location.search) {
            var params = Object.fromEntries(new URLSearchParams(location.search));

            if (checkDataParamsChange(params)) {
                fetch(domain + "/int-search", { method: "POST", body: JSON.stringify({ ...params, getTotalPages: true }) }).then(async response => {
                    var result = await response.json();
                    changeTotalPages(result.totalPages ? result.totalPages : 0);
                    lastParams = params;
                });
            }

            fetch(domain + "/int-search", { method: "POST", body: JSON.stringify(params) }).then(async response => {
                var result = await response.json();

                setChecked(true);
                resultSet.set(result);
            });

            var urlCurrentPage = (isNaN(params.offset) ? 1 : (Number(params.offset) + 1));
            if (currentPage != urlCurrentPage) {
                setCurrentPage(urlCurrentPage);
                setPageInputValue(urlCurrentPage);
            }

            lastLocationParams = location.search;
        } else {
            setChecked(true);
        }


    }, [location]);

    function checkDataParamsChange(params) {
        var checkParams = ["ref", "type", "region", "location", "bedrooms", "from", "to"];

        var changed = false;
        checkParams.forEach(param => changed |= params[param] != lastParams[param])

        return !!changed;
    }

    function changeQuery(params) {
        var currentParams = Object.fromEntries(new URLSearchParams(location.search));
        var newParams = { ...currentParams, ...params };

        var newpath = location.pathname;
        newpath += "?" + new URLSearchParams(newParams).toString();
        history.push(newpath);
        setTimeout(() => topScrollRef.current.scrollIntoView({ behavior: "smooth" }), 200);
    }

    // console.log(typeof (properties));

    return (
        <>
            {(() => {
                // if (properties) {
                return (

                    <div className="search-result-container m-auto">
                        <div style={{ position: "absolute", top: "calc(var(--cont-top) * -1)", display: "invisible" }} ref={topScrollRef} >the</div>

                        <div className="row no-gutters align-items-center">
                            <BackButton className="col-12 col-md-2 mt-3 mb-4" />

                            <h1 className="col search-result-title w-100 text-center" >Search results</h1>

                            <div className="col-12 col-md-4 col-lg-3 col-xl-2 search-result-sort d-flex flex-row align-items-center">
                                <div className="d-flex align-items-center search-result-sort-icon-cnt">
                                    <IoIosFunnel size="20" className="search-result-sort-icon" />
                                </div>
                                <select className="form-control" ref={selectSort} onChange={e => {
                                    changeQuery({ pricesort: e.target.value, offset: 0 });
                                }}>
                                    something
                                    <option value="ascending">
                                        laag naar hoog
                                    </option>
                                    <option value="descending">
                                        hoog naar laag
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div className="row search-result justify-content-center">

                            {((properties.length > 0) ? (properties.map(item => {
                                var key = Object.keys(item)[0];
                                return <Item key={key} refno={key} data={item[key]} ImageCache={ImageCache} />
                            })) : (

                                checked && <h1 className="text-center col-12 " style={{ margin: "20vh 0", color: "gray" }}>No results found</h1>
                            ))}

                        </div>

                        {checked && (properties.length > 0) && <div className="w-100 d-flex justify-content-center">
                            <div className="search-result-pagination-cnt d-flex align-items-center">

                                {(currentPage != 1) && <div className="d-flex align-item-center search-result-pagearrows">
                                    <RiArrowLeftSLine size="40"
                                        onClick={e => {
                                            changeQuery({ offset: (Math.max(currentPage - 1, 1) - 1) });
                                        }}
                                    />
                                </div>}

                                <input type="number" min="1" value={pageInputValue} onChange={e => {
                                    var page = page = Number(e.target.value);
                                    page = isNaN(page) ? 1 : page;
                                    page = Math.min(page, totalPages);
                                    if (page < 1) page = 1;
                                    setPageInputValue(page);
                                }}
                                    onKeyDown={(e) => {
                                        if (e.key == "Enter") {
                                            changeQuery({ offset: (pageInputValue - 1) })
                                        }
                                    }}
                                />
                                <div>&nbsp;out of {totalPages}</div>

                                {(currentPage < totalPages) && <div className="d-flex align-item-center search-result-pagearrows">
                                    <RiArrowRightSLine size="40"
                                        onClick={e => {
                                            changeQuery({ offset: (Math.min(currentPage + 1, totalPages) - 1) });
                                        }}
                                    />
                                </div>}

                            </div>
                        </div>}

                        {checked && <div className="row no-gutters">
                            <div className="col m-5" style={{ paddingLeft: "90px" }}>
                                <BackButton />

                                {/* <Link to="/search" className="gobackbutton">
                                    <h1 className="text-center gobackbutton">&#60; Go Back</h1>
                                </Link> */}
                            </div>
                        </div>}

                    </div>
                );
                // } else {
                //     history.push("/");
                //     return "";
                // }
            })()}
        </>
    );
}

export default SearchResult;